import React from "react";
import { config } from "../../config/config";
import { getSdk } from "../../services/sdkService";
import { EpisodesSelector, Detail, Loading, withFocusable } from "../../services/visualLibraryService";
import { getSupportedVideoTechnology, getSupportedVideoTechnologyLowEnd } from "../../services/assetTypesService";
import { getSeasonsAndEpisodesList, STARZ } from "../../utils/mediaDataRetrieval";
import {
  DetailPageStyled,
  ArrowScrollStyled,
  DetailContainerStyled,
  DetailWrapperStyled,
  DisclaimerText,
  IconStyled,
  DisclaimerTextStyled
} from "./styles/Styled";
import { withAppState, getAppState } from "../../state";
import { startApp } from "../../index";
import { resolution } from "../../config/ui/resolutionConfig";
import { showAndReportUserRelatedError } from "../../errors/utils";
import {
  getGlobalButtonInfo,
  getGlobalButtonFocusPath,
  getConfigForModalWithCloseButton
} from "../../errors/globalButtons";
import sorter from "../../utils/sortObjectsArray";
import { isUserSubscribedToChannel, isAddonContent, isChampionsTrophyAddOn } from "../../utils/subscriptionUtils";
import { i18n } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import {
  showResolutionModal,
  showNotLoggedModal,
  showRetryOrBackModal,
  showForceLogoutError,
  showExpiredContentModal,
  showSignupPremiumPrompt,
  showContentNotAccessibleModal,
  showQRCodeModal
} from "../../services/modalsService";
import { formatDetailData, getEpisodeLabel } from "../../services/copyService";
import { trackPage, trackEvent, sendUserEvent } from "../../services/analyticsService";
import {
  getTrailerVideoData,
  getVideoDataForPlayer,
  getMediaContentData,
  buyAssetDetails,
  getExpireTagTime,
  expirationDate,
  getYouboraPrams,
  getAdsCountryRightsData,
  getStreamingURL,
  isEnableNoDrm
} from "../../services/mediaService";
import { getUserMediaLists, myListHandler, checkMediaListsData } from "../../services/mediaListService";
import {
  redirectTo,
  trackAndRedirectHandler,
  getNavigationReferences,
  isComingFromDetailPageScope
} from "../../services/navigationService";
import {
  isSuitableFor4KPlayback,
  getTrailer,
  getSeasonsList,
  isSeriesDetailPage,
  getSeasonEpisodeFromMediaGuid,
  findFirstEpisodeBySeason,
  has4KProgramId,
  getEpisodeSelectorData,
  isAvodAssets
} from "../../services/titleDataService";
import getRemoteKey from "../../services/remoteService";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";
import { routes } from "../../routes";
import {
  isTVODContent,
  isSVODContent,
  getAssetPrices,
  redirectToBuyBrandsPage,
  isTVODPriority,
  isSVODPriority,
  isContentActive,
  isTvodExpired,
  isTvodFlowForPlayback,
  setCurrentStatusForPlayer,
  getBrandsName,
  getBuyBrandsInfoObjChampionsTrophy,
  getBuyBrandsInfoObj
} from "../../utils/tvodUtils";
import { getTVODAssetsStatus } from "../../services/tvodService";
import { getMultiTaggedAddOnContent } from "../../utils/addOnsUtil";
import { getAllMops } from "../../services/paymentService";
import { showSubscriptionModal } from "../../utils/subscriptionUtils";
import {
  isEpisodePlayable,
  isFreeEpisodeTag,
  isFVODFreeToAir,
  removeHyphens,
  extractSeasonNumber
} from "../../utils/fvodUtils";
import { SentrycaptureError } from "../../utils/SentryStorageLogger";
import {
  sendVideoPlayClickEventDataForBytePlus,
  sendTrueViewImpressionForBytePlus,
  getContentTypeForAnalytics
} from "../../services/byteEventService";
import { getCurrentProfile } from "../../services/multipleProfilesService";
import { isHidePromptForKidsProfile } from "../../utils/promptUtils";
import { getSponsorBug, impressionTracking } from "../../services/sponsorAdService";

const HAS_4K = "4kProgramId";
const MEDIAGUID = "mediaGuid";
const PAGE = "detail";
const PAGE_EPISODE = "episodeSelector";
const PLAY_FROM_LABEL = "details_screen";
const BUTTONS_LIST_NONMOVIES = [
  "buttonPlay",
  "buttonTrailer",
  "buttonWatchlist",
  "buttonRestart",
  "buttonBuy",
  "buttonSponsored"
];
const EPISODEFOCUS = "episodesCarousel";
const SEASONFOCUS = "seasonsCarousel";
const TVOD = "TVOD";
let sdk = null;
const ArrowScrollFocus = withFocusable(ArrowScrollStyled);
let SendAnalyticsCallEpisodeOnce = true;
let fromWhere = null;
//let signupInactivePromptTimer = null;

class DetailPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isExiting = false;
    // FIXME this state is too cluttered (too many elements are added to it when not needed). Not only here, across all the component
    this.state = {
      isLoading: false,
      titleData: null,
      backgroundCover: undefined,
      video: undefined,
      trailer: undefined,
      hasEpisodes: false,
      episodeSelectorLoaded: false,
      isSavedInMyWatchlist: false,
      has4K: false,
      isLoaded: false,
      hasAllDataLoaded: false,
      firstEpisodeAvailable: undefined,
      isPlaying: false,
      slidePage: 0,
      isOnLG: false,
      subscriptionPerCountry: null,
      titleSubscriptions: [],
      tvImpressionWatchedList: [],
      sponsorBug: true
    };
    this.wheelState = "idle";
    this.fetchData = this.fetchData.bind(this);
    this.playHandler = this.playHandler.bind(this);
    this.goToTrailer = this.goToTrailer.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.seasonChanged = this.seasonChanged.bind(this);
    this.tvodBtnText = this.tvodBtnText.bind(this);
    this.DisclaimerText = this.DisclaimerText.bind(this);
    this.assetHandler = this.assetHandler.bind(this);
    this.play = this.play.bind(this);
    this.getVideoData = this.getVideoData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onBack = this.onBack.bind(this);
    this.sponsorBugHandler = this.sponsorBugHandler.bind(this);
    this.isRestarting = false;
    this.clearRefreshTimeout = null;
    this.props.stateActions.applyKidsTheme();
    this.isSeries = isSeriesDetailPage.call(this);
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
    this.promptRef = React.createRef();
    this.currentProfile = null;
    this.isKidsContent = false;
    this.ageRestriction = false;
    this.kidsProfileEnabled = false;
    this.signupInactivePromptTimer = null;
    this.showQRCodeModal = false;
  }

  async componentWillReceiveProps(newProps) {
    try {
      if (newProps.location.pathname !== this.props.location.pathname) {
        if (
          (this.props.location && this.props.location.state && !!this.props.location.state.deepLinkReferrer) ||
          (newProps.location && newProps.location.state && !!newProps.location.state.deepLinkReferrer)
        ) {
          this.setState({ backgroundCover: null, hasEpisodes: false, hasAllDataLoaded: false });
          this.props.onRef(this);
        }
        this.props.applicationState.userMediaCached = null;
        this.progress = null;
        this.setState({ titleData: null });
        this.setState({ titleData: await this.fetchData() });
      }
    } catch (e) {
      SentrycaptureError(e);
    }
  }

  async componentDidUpdate() {
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
  }

  async componentWillUnmount() {
    this.isExiting = true;
    this.mounted = false;
    if (this.clearRefreshTimeout) {
      clearTimeout(this.clearRefreshTimeout);
    }
    this.clearRefreshTimeout = null;
    !!getAppState().globalModal && this.props.stateActions.hideGlobalModal();
    await this.clearPrompt();
    document.removeEventListener("keydown", this.keydownHandler);
  }

  async clearPrompt() {
    if (this.signupInactivePromptTimer) {
      clearTimeout(this.signupInactivePromptTimer);
    }
  }

  keydownHandler = e => {
    const { hasEpisodes } = this.state;
    const pressedKey = getRemoteKey(e.keyCode);
    this.wheelState = "idle";
    if (pressedKey === "MEDIA_PLAY") {
      this.playHandler(false);
    } else if (pressedKey === "ARROW_DOWN") {
      if (
        hasEpisodes &&
        this.seasonsList &&
        this.episodesList &&
        BUTTONS_LIST_NONMOVIES.indexOf(this.props.applicationState.currentFocus) > -1
      ) {
        this.props.setFocus(EPISODEFOCUS);
        this.setState({
          slidePage: -resolution.detail.positionListEpisodesDown
        });

        if (SendAnalyticsCallEpisodeOnce === true) {
          trackPage.call(this, PAGE_EPISODE);
          SendAnalyticsCallEpisodeOnce = false;
        }
      }
    } else if (pressedKey === "ARROW_UP") {
      if (
        hasEpisodes &&
        this.seasonsList &&
        this.episodesList &&
        this.props.applicationState.currentFocus === SEASONFOCUS
      ) {
        this.props.setFocus(BUTTONS_LIST_NONMOVIES[0]);
        this.setState({
          slidePage: resolution.detail.positionListEpisodesUp
        });
      }
    }
  };

  async componentDidMount() {
    try {
      this.props.setFocus(BUTTONS_LIST_NONMOVIES[0]);

      /** Special case for FVOD - Start */
      localStorage.removeItem("playerReferrer");
      /** Special case for FVOD - End */

      const getPlatform = await getSdk().systemManager.device.getPlatform();
      this.setState({
        isOnLG: getPlatform === "webos" ? true : false
      });
      const { history, location } = this.props;
      const { userLogged } = this.props.applicationState;
      this.mounted = true;
      document.addEventListener("keydown", this.keydownHandler);
      sdk = await getSdk();
      if (!isComingFromDetailPageScope.call(this)) {
        // This will happen when the deep linking is used and in this case the media list cache needs to be removed in
        // order to get the new title's media list data and not show the previous one's.
        this.props.applicationState.userMediaCached = null;
        this.progress = null;
      }
      this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();

      location.state && !!location.state.deepLinkReferrer && (await startApp());
      trackPage.call(this, PAGE);
      this.setState({
        titleData: await this.fetchData(),
        isLoaded: true,
        isPlaying: false
      });
      this.props.onRef(this);
      fromWhere = this.props.location.referrer;
      // Send event
      !this.state.unAuthorizedAccess &&
        this.props.applicationState.userLogged &&
        this.props.location.referrer &&
        this.props.location.referrer.search(/\/(episodes|player)$/) === -1 &&
        this.props.location.referrer !== this.props.location.pathname &&
        sendUserEvent({
          module_id: history.location.state ? history.location.state.moduleId : null,
          id: this.state.id,
          action: "detail_page"
        });
      if (this.ageRestriction && this.state.titleData) {
        return showContentNotAccessibleModal.call(this, this.closeModal, {
          dismissable: false
        });
      }
      if (this.state.titleData && this.state.titleData.isLive === false && this.state.titleData.tagList === "series") {
        await this.updateEpisodeData();
        await this.checkUpdatedEpisodes();
      }
      this.props.setFocus(Detail.defaultFocusPath);
      userLogged && !isAvodAssets(this.state.titleData?.assetTypes) && (await getAllMops.call(this));
      sdk.playerManager.stop();
      // Force logout listening
      showForceLogoutError.call(this);
      await this.reloadWait(1000);
      if (this.props.applicationState.currentFocus === "episodesCarousel") {
        this.setState({
          slidePage: -resolution.detail.positionListEpisodesDown
        });
      }
      const userAccountStatus = await this.getUserAccountStatus();
      const userAddonStatus = await this.getUserAddonStatus();
      const isHidePromptForkids = await isHidePromptForKidsProfile();
      if (
        getAppState()?.signupPromptActive &&
        !isUserAccountActive(userAccountStatus) &&
        !userAddonStatus &&
        !isHidePromptForkids
      ) {
        this.startSignupInactivePromptTimer();
      }
      // byte+ trueview impression event
      if (this.isSeries) {
        let tvS = this?.lastSeenEpisode?.tvSeasonNumber;
        this.seasonChanged(tvS ? tvS - 1 : 0);
        // sendTrueViewImpressionForBytePlus({ carouselContents: (this.isSeries && this.episodesList) || null });
      } else {
        sessionStorage.setItem("currentlyPlayingid", this.getContentIdFromUrl());
      }
      // if came back from player_page, revert prev page to its prev page toa void passing prev_page as player in byte+ events
      if (sessionStorage.getItem("prevScreen") == "player_page") {
        sessionStorage.setItem("prevScreen", sessionStorage.getItem("prevScreen2"));
      }
      // Adtech Impression Tracking Call
      if (this.state.sponsorBug) {
        await impressionTracking(this.state.sponsorBug?.impressionTrackingURL);
      }
    } catch (e) {
      SentrycaptureError(e);
    }
  }

  startSignupInactivePromptTimer = () => {
    if (this.signupInactivePromptTimer !== null) clearTimeout(this.signupInactivePromptTimer);
    this.signupInactivePromptTimer = setTimeout(() => {
      const hasAnyModalOpened = getAppState()?.globalModal;
      if (!hasAnyModalOpened || (hasAnyModalOpened && Object.keys(hasAnyModalOpened).length == 0)) {
        showSignupPremiumPrompt.call(this, getNavigationReferences.call(this), this.closeModal);
      }
    }, getAppState().signupPromptTimer || 5000);
  };

  getUserAccountStatus = async () => {
    return getAppState()?.userAccountStatus;
  };

  getUserAddonStatus = async () => {
    return getAppState()?.userAddonStatus;
  };

  reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }
  closeModal(focusPath = Detail.defaultFocusPath) {
    const { history, location } = this.props;
    const isDeepLinkReferrer = location.state && !!location.state.deepLinkReferrer;
    this.props.stateActions.hideGlobalModal();
    if (this.showQRCodeModal) {
      this.props.setFocus(BUTTONS_LIST_NONMOVIES[5]);
    } else {
      this.props.setFocus(focusPath);
    }
    if (getAppState().signupPromptActive) getAppState().signupPromptActive = false;
    if (this.ageRestriction && isDeepLinkReferrer) {
      this.ageRestriction = false;
      history.push(routes.home, {
        deepLinkReferrer: false
      });
    } else if (this.ageRestriction) {
      this.ageRestriction = false;
      history.goBack();
    }
  }

  async updateEpisodeData() {
    const { history, location } = this.props;
    history.replace({
      ...location,
      state: {
        ...(await getEpisodeSelectorData.call(this)),
        from: location?.state?.from
      }
    });
    this.setState({ hasAllDataLoaded: true });
  }

  getDataToSentBuyAsset(addonContent = null) {
    return {
      title: this.state.title,
      addonContent: addonContent || this.state.addonContent,
      titleId: this.state.id,
      price: null
    };
  }

  setFocusAfterModalOpen(focusPath) {
    const { setFocus } = this.props;
    setTimeout(() => {
      this.props.resumeNavigation();
    }, 1);
    setFocus(focusPath);
  }

  async playHandler(isRestarting) {
    try {
      const {
        match: {
          params: { titleId }
        },
        history: { location },
        applicationState: { userLogged, userAccountStatus, addons, currentFocus, isGuestProfile },
        setFocus,
        stateActions
      } = this.props;
      const episodesLoaded = !this.isSeries || (await this.episodesLoad);
      const videoData = episodesLoaded && (await getVideoDataForPlayer.call(this, false));

      let eventAction = (isRestarting === true && "play_from_beginning") || "play";
      trackEvent(PAGE, eventAction, titleId);
      const boundCloseModal = this.closeModal.bind(this, currentFocus);
      this.isRestarting = isRestarting;
      const { titleData } = this.state;
      const freeEpisodes = (titleData && titleData.freeEpisodes) || [];
      const tvSeasonNumber = videoData.tvSeasonNumber || 1;
      const tvSeasonEpisodeNumber = videoData.tvSeasonEpisodeNumber || 1;
      if (isEpisodePlayable(freeEpisodes, tvSeasonNumber, tvSeasonEpisodeNumber)) {
        await this.clearPrompt();
        await showResolutionModal.call(this, isSuitableFor4KPlayback(has4KProgramId.call(this)));
        return;
      }
      if (userLogged) {
        const { isTVOD, assetPrices, titleSubscriptions = [], addonContent, subscriptionPerCountry } = this.state;
        const tvodStatus = isTVOD && (await getTVODAssetsStatus(titleId));

        if (isTVOD && isTvodExpired(tvodStatus)) {
          const { rentCtaData, purchaseCtaData } = assetPrices || {};

          if (Object.keys(rentCtaData).length !== 0 && Object.keys(purchaseCtaData).length !== 0) {
            const eventData = {
              pageType: `details-${titleData.tagList}`,
              pathname: location.pathname,
              titleId: titleData.id,
              title: titleData.title,
              addonContent,
              tagList: titleData.tagList,
              profileId: this.currentProfile?.profileId
            };
            return showExpiredContentModal.call(this, this.closeModal, assetPrices, eventData);
          } else if (Object.keys(rentCtaData).length !== 0 && Object.keys(purchaseCtaData).length === 0) {
            return trackAndRedirectHandler.call(
              this,
              PAGE,
              "rentLabel",
              routes.buyasset,
              buyAssetDetails.call(this, "rentLabel", rentCtaData)
            );
          } else {
            return trackAndRedirectHandler.call(
              this,
              PAGE,
              "purchaseLabel",
              routes.buyasset,
              buyAssetDetails.call(this, "purchaseLabel", purchaseCtaData)
            );
          }
        }
        if (!isTvodFlowForPlayback(tvodStatus) && !isAvodAssets(this.state.titleData?.assetTypes)) {
          let isUserSubscribedToAsset = isUserSubscribedToChannel(addons, addonContent, titleSubscriptions);
          const multiTaggedAddOnContent = getMultiTaggedAddOnContent.call(
            this,
            isUserSubscribedToAsset,
            addonContent,
            subscriptionPerCountry
          );
          isUserSubscribedToAsset = isUserSubscribedToChannel(addons, multiTaggedAddOnContent, titleSubscriptions);
          if (
            this.isKidsContent &&
            this.kidsProfileEnabled &&
            !isUserAccountActive(userAccountStatus) &&
            !isAddonContent(multiTaggedAddOnContent)
          ) {
            const subscriptionName = getBrandsName(addons, addonContent);
            return showContentNotAccessibleModal.call(this, this.closeModal, {
              isSVODContent: true,
              name: subscriptionName?.displayName
            });
          }
          if (!isUserAccountActive(userAccountStatus) && !isAddonContent(multiTaggedAddOnContent)) {
            showSubscriptionModal.call(
              this,
              multiTaggedAddOnContent,
              true,
              null,
              null,
              isChampionsTrophyAddOn(addonContent)
            );
            return;
          }

          if (!isUserSubscribedToAsset) {
            showSubscriptionModal.call(
              this,
              multiTaggedAddOnContent,
              true,
              null,
              null,
              isChampionsTrophyAddOn(addonContent)
            );
            return;
          }

          this.isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, multiTaggedAddOnContent);
          if (!this.isThisDeviceSupported) {
            return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
          }
        }

        this.isRestarting = isRestarting;
        if (!!getAppState().isOnline) {
          await this.clearPrompt();
          await showResolutionModal.call(this, isSuitableFor4KPlayback(has4KProgramId.call(this)));
          return;
        } else {
          stateActions.showGlobalModal(
            getConfigForModalWithCloseButton(
              {
                title: i18n.get("global.errors.internetConnectivity.title"),
                text: i18n.get("global.errors.internetConnectivity.text")
              },
              boundCloseModal
            )
          );
          setFocus(getGlobalButtonFocusPath("close"));
        }
      } else if (isGuestProfile && isAvodAssets(this.state.titleData?.assetTypes)) {
        if (!!getAppState().isOnline) {
          await this.clearPrompt();
          this.isRestarting = isRestarting;
          await showResolutionModal.call(this, isSuitableFor4KPlayback(has4KProgramId.call(this)));
          return;
        }
      } else {
        showNotLoggedModal.call(this, getNavigationReferences.call(this));
      }
      return false;
    } catch (e) {
      SentrycaptureError(e);
    }
  }

  getContentIdFromUrl() {
    let contentId = window.location.pathname.match(/\d+/);
    if (contentId && contentId?.length > 0) {
      return contentId[0];
    }
  }
  seriesOrMovie(trueIfSeries) {
    let content = window.location.pathname.match(/[a-z]+/);
    if (content && content?.length > 0) {
      if (content[0] == "series") {
        if (trueIfSeries) {
          return "yes";
        } else {
          return "series";
        }
      } else {
        if (trueIfSeries) {
          return "no";
        } else {
          return "movie";
        }
      }
    }
  }

  async handleEnter(episodeTitle) {
    try {
      // Byte+ GA event for play click
      if (sessionStorage.getItem("prevScreen") != "player_page") {
        sessionStorage.setItem("currScreen2", sessionStorage.getItem("currentScreen"));
        sessionStorage.setItem("prevScreen2", sessionStorage.getItem("prevScreen"));
      }
      episodeTitle.series_id = await this.getContentIdFromUrl();
      sendVideoPlayClickEventDataForBytePlus({
        thisInstance: this,
        carouselOrderId: 0,
        mediaData: episodeTitle,
        currentScreen: sessionStorage?.getItem("currentScreen"),
        previousScreen: sessionStorage?.getItem("prevScreen")
      });
      const {
        match: {
          params: { titleId }
        },
        history: { location },
        applicationState: { userLogged, userAccountStatus, addons, isGuestProfile, currentFocus }
      } = this.props;
      const boundCloseModal = this.closeModal.bind(this, currentFocus);
      // Check FVOD Case first, if FVOD then play
      if (isFVODFreeToAir(episodeTitle.tags)) {
        this.episodeTitle = episodeTitle;
        await this.clearPrompt();
        await showResolutionModal.call(this, isSuitableFor4KPlayback(this.episodeTitle["4kProgramId"]));
        return;
      }

      const { isTVOD, assetPrices, titleSubscriptions = [], subscriptionPerCountry, titleData } = this.state;
      if (userLogged) {
        const { rentCtaData, purchaseCtaData } = assetPrices || {};
        const tvodStatus = isTVOD && (await getTVODAssetsStatus(titleId));
        if (isTVOD && tvodStatus && (isTvodExpired(tvodStatus) || tvodStatus.length === 0)) {
          if (Object.keys(rentCtaData).length !== 0 && Object.keys(purchaseCtaData).length !== 0) {
            const eventData = {
              pageType: `details-${titleData.tagList}`,
              pathname: location.pathname,
              titleId: titleData.id,
              title: titleData.title,
              addonContent: titleData.addonContent,
              tagList: titleData.tagList,
              profileId: this.currentProfile?.profileId
            };
            const modifiedPrices = { isOnDetail: true, ...assetPrices };
            return showExpiredContentModal.call(this, this.closeModal, modifiedPrices, eventData);
          } else if (Object.keys(rentCtaData).length !== 0 && Object.keys(purchaseCtaData).length === 0) {
            return trackAndRedirectHandler.call(
              this,
              PAGE,
              "rent",
              routes.buyasset,
              buyAssetDetails.call(this, "rent", rentCtaData)
            );
          } else {
            return trackAndRedirectHandler.call(
              this,
              PAGE,
              "purchase",
              routes.buyasset,
              buyAssetDetails.call(this, "purchase", purchaseCtaData)
            );
          }
        }
        const addonContent = episodeTitle.addonContent;
        if (!isTvodFlowForPlayback(tvodStatus) && !isAvodAssets(this.state.titleData?.assetTypes)) {
          let isUserSubscribedToAsset = isUserSubscribedToChannel(addons, addonContent, titleSubscriptions);
          const multiTaggedAddOnContent = getMultiTaggedAddOnContent.call(
            this,
            isUserSubscribedToAsset,
            addonContent,
            subscriptionPerCountry
          );

          isUserSubscribedToAsset = isUserSubscribedToChannel(addons, multiTaggedAddOnContent, titleSubscriptions);
          if (
            this.isKidsContent &&
            this.kidsProfileEnabled &&
            !isUserAccountActive(userAccountStatus) &&
            !isAddonContent(multiTaggedAddOnContent)
          ) {
            const subscriptionName = getBrandsName(addons, addonContent);
            return showContentNotAccessibleModal.call(this, boundCloseModal, {
              isSVODContent: true,
              name: subscriptionName?.displayName
            });
          }
          if (!isUserAccountActive(userAccountStatus) && !isAddonContent(multiTaggedAddOnContent)) {
            showSubscriptionModal.call(
              this,
              multiTaggedAddOnContent,
              true,
              null,
              null,
              isChampionsTrophyAddOn(addonContent)
            );
            return;
          }
          if (!isUserSubscribedToAsset) {
            showSubscriptionModal.call(
              this,
              multiTaggedAddOnContent,
              true,
              null,
              null,
              isChampionsTrophyAddOn(addonContent)
            );
            return;
          }
          this.isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, multiTaggedAddOnContent);
          if (!this.isThisDeviceSupported && !isAvodAssets(this.state.titleData?.assetTypes)) {
            return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
          }
        }
        this.episodeTitle = episodeTitle;
        await this.clearPrompt();
        showResolutionModal.call(this, isSuitableFor4KPlayback(this.episodeTitle["4kProgramId"]));
        return;
      } else if (isGuestProfile && isAvodAssets(this.state.titleData?.assetTypes)) {
        if (!!getAppState().isOnline) {
          this.episodeTitle = episodeTitle;
          await this.clearPrompt();
          await showResolutionModal.call(this, isSuitableFor4KPlayback(this.episodeTitle["4kProgramId"]));
        }
      } else {
        showNotLoggedModal.call(this, getNavigationReferences.call(this));
      }
      return false;
    } catch (e) {
      SentrycaptureError(e);
    }
  }

  seasonChanged(seasonIndex) {
    // console.log("Season is changed!")
    if (!this.state.tvImpressionWatchedList.includes(seasonIndex)) {
      let firstIndexOfSeasonEp = this?.episodesList?.findIndex(item => item.tvSeasonNumber === seasonIndex + 1);
      let lastIndexOfSeasonEp = this?.episodesList?.findIndex(item => item.tvSeasonNumber === seasonIndex + 2);
      let episodesToSend = [];
      sessionStorage.setItem("currentlyPlayingid", this.getContentIdFromUrl());
      sessionStorage.setItem("currentlyPlayingisSeries", this.seriesOrMovie(true));
      if (lastIndexOfSeasonEp != -1) {
        for (let i = firstIndexOfSeasonEp; i < lastIndexOfSeasonEp; i++) {
          episodesToSend.push(this.episodesList[i]);
        }
        this.setState({ tvImpressionWatchedList: [...this.state.tvImpressionWatchedList, seasonIndex] });
        sendTrueViewImpressionForBytePlus({ carouselContents: episodesToSend || null });
      } else {
        for (let i = firstIndexOfSeasonEp; i < this.episodesList.length; i++) {
          if (i >= 0) {
            episodesToSend.push(this.episodesList[i]);
          }
        }
        this.setState({ tvImpressionWatchedList: [...this.state.tvImpressionWatchedList, seasonIndex] });
        sendTrueViewImpressionForBytePlus({ carouselContents: episodesToSend || null });
      }
    }
  }

  async checkUpdatedEpisodes() {
    const {
      history: {
        location: { state }
      }
    } = this.props;
    if (fromWhere === routes.player) {
      try {
        const updatedEpisodes = await getSeasonsAndEpisodesList(state.seriesId, true);
        Object.assign(state, {
          episodesList: state.episodesList.map((episode, index) =>
            Object.assign(episode, updatedEpisodes.episodesList[index])
          ),
          lastEpisode: updatedEpisodes.lastEpisode
        });
        this.setState({ isLoaded: true });
      } catch (e) {
        this.setState({ isLoaded: true });
      }
    }

    this.setState({ isLoaded: true });
  }

  goPlayer(videoData) {
    const { history } = this.props;
    this.isExiting = true;
    this.setState({
      isPlaying: true
    });
    // Byte+ GA event for play click
    sessionStorage.setItem("currScreen2", sessionStorage.getItem("currentScreen"));
    sessionStorage.setItem("prevScreen2", sessionStorage.getItem("prevScreen"));
    videoData.series_id = this.getContentIdFromUrl();
    sendVideoPlayClickEventDataForBytePlus({
      thisInstance: this,
      mediaData: videoData,
      currentScreen: sessionStorage?.getItem("currentScreen"),
      previousScreen: sessionStorage?.getItem("prevScreen")
    });
    const { state } = history.location;
    if (state && state.from) {
      delete state.from;
    }
    return redirectTo.call(this, routes.player, {
      ...state,
      ...videoData
    });
  }

  async play(is4K, isSelectedFromResolutionPopup) {
    if (this.props.applicationState.currentFocus !== "episodesCarousel") {
      const {
        setFocus,
        match: {
          params: { titleId }
        }
      } = this.props;
      const episodesLoaded = !this.isSeries || (await this.episodesLoad);
      const videoData = episodesLoaded && (await getVideoDataForPlayer.call(this, is4K));
      Object.assign(videoData, { playFrom: PLAY_FROM_LABEL, whichCTA: this.props.applicationState.currentFocus });
      isSelectedFromResolutionPopup && trackEvent(PAGE, is4K ? "4K" : "HD", titleId);
      sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
      setFocus(Detail.defaultFocusPath);
      await this.clearPrompt();
      this.goPlayer(videoData);
    } else {
      const {
        location: {
          state: { seriesId }
        },
        setFocus,
        stateActions: { hideGlobalModal }
      } = this.props;
      !!getAppState().globalModal && hideGlobalModal();
      const videoData = await this.getVideoData(is4K);
      if (this.mounted) {
        isSelectedFromResolutionPopup && trackEvent("detail", is4K ? "4K" : "HD", seriesId);
        trackEvent(
          "detail",
          "play_from_episode_selector",
          `${seriesId}-S${this.episodeTitle.tvSeasonNumber}E${this.episodeTitle.tvSeasonEpisodeNumber}`
        );
        sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
        setFocus(EpisodesSelector.defaultFocusPath);
        await this.clearPrompt();
        redirectTo.call(this, routes.player, videoData);
      }
    }
  }

  // FIXME There is a really similar function in DetailPage.js, we should have the logic in one place only
  async getVideoData(is4K) {
    const { location } = this.props;
    const getModelDevice = await getSdk().systemManager.device.getRealModel();
    const media = is4K
      ? await this.get4KMediaContent(this.episodeTitle["4kProgramId"])
      : this.episodeTitle.mediaContent[0];
    const noDrmConfig = this.episodeTitle?.config || null;
    const adsCountryRights =
      (await getAdsCountryRightsData.call(
        this,
        this.episodeTitle.tvSeasonNumber,
        this.episodeTitle.tvSeasonEpisodeNumber
      )) || [];
    const streamingData = getStreamingURL(
      adsCountryRights,
      this.episodeTitle?.ecommerceAds,
      noDrmConfig,
      media?.content.video
    );
    const contentOwnership =
      this.state.titleData?.contentOwnership && this.state.titleData?.contentOwnership.length > 0
        ? this.state.titleData?.contentOwnership[0]
        : STARZ;
    return {
      videoType: "series",
      contentTypeYoubora: getContentTypeForAnalytics(this.episodeTitle),
      manifest: streamingData?.streamingUrl || media?.content.video.streamingUrl,
      releasePid: streamingData?.releasePid || media?.content.video.releasePid,
      releaseUrl: streamingData?.releaseUrl || media?.content.video.releaseUrl,
      duration: streamingData?.duration || media?.content.video.duration,
      dash_widevine_ads: streamingData,
      dPlay: noDrmConfig?.dPlay || null,
      isEnableNoDrm: isEnableNoDrm(adsCountryRights, noDrmConfig, media?.content.video) || false,
      filmstrip: media.content.filmstrip,
      adsCountryRights,
      description: this.episodeTitle.shortDescription || this.episodeTitle.description,
      title: this.episodeTitle.title,
      tvSeasonNumber: this.episodeTitle.tvSeasonNumber,
      tvSeasonEpisodeNumber: this.episodeTitle.tvSeasonEpisodeNumber,
      playbackTime: (this.episodeTitle.progress && this.episodeTitle.progress.playbackTime) || 0,
      seriesTitle: location.state.seriesTitle,
      episodeLabel: getEpisodeLabel(this.episodeTitle.tvSeasonNumber, this.episodeTitle.tvSeasonEpisodeNumber),
      seasonsList: this.seasonsList,
      episodesList: this.episodesList || location.state.episodesList,

      contentType: isFVODFreeToAir(this.episodeTitle.tags) ? "FVOD" : this.episodeTitle.assetTypesPriority,
      assetTypesPriority: this.episodeTitle.assetTypesPriority,
      profileType: getAppState().currentProfileType,
      contentOwnership,

      id: this.episodeTitle.id,
      seriesId: location.state.seriesId,
      moduleId: location.state.moduleId,
      has4K: location.state.has4K,
      //externalSubtitles: is4K && media.content.subtitles
      externalSubtitles: media.content.subtitles,
      mediaGuid: media.mediaGuid,
      credits: media.credits,
      playFrom: PLAY_FROM_LABEL,
      whichCTA: this.props.applicationState.currentFocus,
      genres: this.state.titleData.genres,
      assetTypes: this.state.titleData.assetTypes,
      backgroundCover: this.state.backgroundCover,
      isEnableVideoCommerce: this.episodeTitle?.ecommerceAds || false,
      content_language: this.episodeTitle.languages[0],
      content_rating: this.state.titleData.ageRating,
      device_model: getModelDevice,
      enforceAds: noDrmConfig?.enforceAds || false
    };
  }

  async get4KMediaContent(id) {
    let title;
    try {
      const { location } = this.props;
      if (this.episodesList && this.episodesList.length) {
        title = this.episodesList.find(episode => !!episode["4kProgramId"] && episode["4kProgramId"] === id);
      } else {
        title = await sdk.mediaManager.getTitle(id, { is4K: true });
      }
      return title.title4K ? title.title4K.mediaContent[0] : title.mediaContent[0];
    } catch (e) {
      if (this.mounted) {
        showAndReportUserRelatedError.call(this, {
          modalText: i18n.get("global.errors.genericError"),
          buttons: [
            {
              ...getGlobalButtonInfo("close"),
              buttonHandler: this.closeModal
            }
          ]
        });
        this.props.setFocus(getGlobalButtonFocusPath("close"));
      }
    }
  }

  onBack() {
    const {
      match: {
        params: { titleId }
      },
      stateActions,
      applicationState,
      location,
      history
    } = this.props;
    if (this.ageRestriction) return true;
    const dismissable = applicationState.globalModal && applicationState.globalModal.dismissable;
    trackEvent(PAGE, "back", titleId);
    if (!!applicationState.globalModal) {
      this.closeModal();
      if (!dismissable) {
        return true;
      }
    }
    applicationState.userMediaCached = null;
    if (
      location.referrer === "/pin-signup" ||
      applicationState.isDeepLinkReferrer ||
      location.referrer === "/profile-selector" ||
      location.referrer === "/buybrands"
    ) {
      applicationState.isDeepLinkReferrer = false;
      history.push("/home");
      return true;
    }
    this.isExiting = true;
    const to = location.state?.from?.name === "/" ? "/home" : location.state?.from?.name;
    if (to === "/search") {
      history.goBack();
      return true;
    }
    if (history.location.referrer === "/pin-signup") {
      history.push("/home");
      return true;
    }
    if (to) {
      history.replace(to, {
        ...(location.state || {})
      });
      return true;
    }
    history.goBack();
    return true;
  }

  getIconButtonPlay() {
    const {
      applicationState: { addons }
    } = this.props;
    const { addonContent } = this.state;
    return !isUserSubscribedToChannel(addons, addonContent) ? "premiumContentEmpty" : "play";
  }

  async fetchData() {
    sdk = await getSdk();
    try {
      const {
        applicationState: { userLogged, country, addons, isGuestProfile, isActiveUser, isSvodUser },
        match: {
          params: { titleId }
        }
      } = this.props;
      const requests = [
        sdk.mediaManager.getTitle(titleId, {
          is4K: true,
          offline: !getAppState().isOnline,
          country
        }), // [0] Title
        getCurrentProfile()
      ];

      const results = requests.map(async req => await req);
      const title = await results[0];
      this.currentProfile = await results[1];
      // FVOD CAse
      if (this.isSeries && isFVODFreeToAir(title.tags)) {
        this.isThisSeriesHasFreeEpisodes = title.freeEpisodes && title.freeEpisodes.length > 0 ? true : false;
        localStorage.setItem("isThisSeriesHasFreeEpisodes", this.isThisSeriesHasFreeEpisodes);
        this.freeEpisodes = isActiveUser ? [] : title.freeEpisodes;
        title.tags = title.tags || [];
        const freeEpTag = isActiveUser ? "" : isFreeEpisodeTag(title.tags);
        if (freeEpTag && !isSvodUser) {
          title.remTime = freeEpTag;
        }
      }
      // AdtechProject - Getting sponsor Bug - Start
      let sponsorBug = null;
      if (this.props.applicationState.showSponsorBugs) {
        sponsorBug = await getSponsorBug(title);
      }
      // AdtechProject - Getting sponsor Bug - End
      if (this.isSeries) {
        // FIXME: This should be done in the middleware instead.
        title.mediaContent.sort(sorter(MEDIAGUID));

        // Map the 4K episodes.
        this.title4K = {};
        !!title.title4K &&
          !!title.title4K.mediaContent &&
          title.title4K.mediaContent.forEach(
            media => (this.title4K[getSeasonEpisodeFromMediaGuid(media.mediaGuid)] = media)
          );
      }
      if ((userLogged || isGuestProfile) && title.isLive === false) {
        await getUserMediaLists(titleId, checkMediaListsData.bind(this));
      } // [1] User Media
      const seasons = this.isSeries ? await getSeasonsList.call(this, titleId, country) : [];

      //userLogged && (await results[1]);

      const videoType = getSupportedVideoTechnology();

      const firstEpisode =
        this.isSeries && findFirstEpisodeBySeason(title.mediaContent, this.seasonsListRaw[0].tvSeasonNumber);
      let firstEpisodeFromMediaGuid = firstEpisode && getSeasonEpisodeFromMediaGuid(firstEpisode.mediaGuid);
      let firstEpisodeNumber = firstEpisodeFromMediaGuid && parseInt(firstEpisodeFromMediaGuid.split("E")[1]);
      let firstEpisodeAvailable =
        this.isSeries && !this.resumeEpisode
          ? getEpisodeLabel(this.seasonsListRaw[0].tvSeasonNumber, !isNaN(firstEpisodeNumber) && firstEpisodeNumber)
          : undefined;

      // Show First Free & Playable Episode
      if (this.freeEpisodes && this.freeEpisodes.length > 0) {
        firstEpisodeFromMediaGuid = removeHyphens(this.freeEpisodes[0]);
        firstEpisodeNumber = firstEpisodeFromMediaGuid && parseInt(firstEpisodeFromMediaGuid.split("E")[1]);
        const seasonNumber = firstEpisodeFromMediaGuid && extractSeasonNumber(firstEpisodeFromMediaGuid);
        firstEpisodeAvailable =
          this.isSeries && !this.resumeEpisode
            ? getEpisodeLabel(seasonNumber, !isNaN(firstEpisodeNumber) && firstEpisodeNumber)
            : undefined;
      }
      const mediaHD = getMediaContentData.call(this, title, false);
      const media4K = !!title.title4K && getMediaContentData.call(this, title.title4K, true);
      this.mediaData = {
        mediaHD,
        media4K,
        videoHD: mediaHD.content.video[videoType] || mediaHD.content.video,
        video4K: !!media4K && (media4K.content.video[videoType] || media4K.content.video)
      };

      /* 
        First check assetTypes, check the first element of the array, if it is TVOD then check user rented
        or buy that content, if it buy then TVOD flow, if he does not buy then check if array contains 
        the SVOD in array, if array
      */
      /*
        A content is tagged with both TVOD & SVOD, Priority is set to TVOD
        We do a check whats is the subscription this content is tagged with
        Next check we check whether the user is active on the respective subscription
        No: TVOD priority
        Yes: Same as today with ability to play since its an svod and respective subscription already active
      */

      const tvodStatus = userLogged && isTVODContent(title.assetTypes) && (await getTVODAssetsStatus(title.id));
      const isTvodFlow = isTvodFlowForPlayback(tvodStatus);
      let isTVOD = isTvodFlow;
      let priceData = null;
      if (!isTvodFlow) {
        const isAssetActive = isSVODContent(title.assetTypes)
          ? isContentActive(addons, title.addonContent, title.subscription)
          : false;
        isTVOD =
          !isAssetActive && title.assetTypes && title.assetTypesPriority && isTVODPriority(title.assetTypesPriority)
            ? isTVODContent(title.assetTypes)
            : false;
        const assetPrices = !isAssetActive && isTVOD && (await getAssetPrices(title, country, isTVOD, tvodStatus));
        if (assetPrices && assetPrices.length !== 0) {
          priceData = this.tvodBtnText(assetPrices);
        }
      }

      if (tvodStatus && tvodStatus.length > 0) {
        // cll this add expiry time to title
        tvodStatus && getExpireTagTime(title, tvodStatus);
        tvodStatus && getYouboraPrams(title, tvodStatus);
        tvodStatus && setCurrentStatusForPlayer(tvodStatus);
      }
      if (tvodStatus && tvodStatus.length >= 0) {
        title &&
          title.mediaContent.length > 0 &&
          title.mediaContent[0].expirationDate &&
          expirationDate(title, tvodStatus);
      }
      this.isKidsContent = title.ageRating === "PG" || title.ageRating === "G" ? true : false;
      this.ageRestriction =
        (this.currentProfile?.profileCategory === "KIDS" || Number(this.currentProfile?.parentalControl) <= 7) &&
        !this.isKidsContent
          ? true
          : false;
      this.kidsProfileEnabled = this.currentProfile?.profileCategory === "KIDS" ? true : false; // for kids profile
      const buyBrandsInfoObjChampionsTrophy =
        isChampionsTrophyAddOn(title.addonContent) &&
        getBuyBrandsInfoObjChampionsTrophy.call(this, addons, title.addonContent);
      const buyBrandsInfoObj = getBuyBrandsInfoObj.call(this, addons, title.addonContent);
      this.setState({
        isOneTimePassPriorityFlag:
          (buyBrandsInfoObjChampionsTrophy && buyBrandsInfoObjChampionsTrophy.isOneTimePassPriorityFlag) || false,
        isOneTimePassActive: (buyBrandsInfoObj && buyBrandsInfoObj.isOneTimePassActive) || false,
        backgroundCover: title.images.hero,
        firstEpisodeAvailable,
        trailer: getTrailer(title),
        title: title.title,
        description: title.shortDescription,
        id: title.id,
        has4K: !!title[HAS_4K],
        addonContent: title.addonContent,
        isLive: title.isLive,
        contentType: getContentTypeForAnalytics(title),
        programType: title.programType,
        isTVOD: isTVOD,
        adsCountryRights: title.adsCountryRights,
        assetPrices: priceData,
        tvodStatus: tvodStatus,
        titleSubscriptions: title.subscription || [],
        subscriptionPerCountry: title.subscriptionPerCountry,
        sponsorBug
      });
      return formatDetailData.call(this, title, seasons, priceData, sponsorBug);
    } catch (e) {
      SentrycaptureError(e);
      !this.isExiting && showRetryOrBackModal.call(this, e);
    }
  }

  scrollUpDown(event) {
    this.wheelState = "active";
    if (event.deltaY > 0) {
      // down wheel moves
      if (this.state.hasEpisodes && this.seasonsList && this.episodesList) {
        if (BUTTONS_LIST_NONMOVIES.indexOf(this.props.applicationState.currentFocus) > -1) {
          this.props.setFocus(EPISODEFOCUS);
          this.setState({
            slidePage: -resolution.detail.positionListEpisodesDown
          });
          if (SendAnalyticsCallEpisodeOnce === true) {
            trackPage.call(this, PAGE_EPISODE);
            SendAnalyticsCallEpisodeOnce = false;
          }
        } else if (this.props.applicationState.currentFocus === SEASONFOCUS) {
          this.props.setFocus(EPISODEFOCUS);
        }
      }
    } else if (event.deltaY < 0) {
      // up wheel moves
      if (this.state.hasEpisodes && this.seasonsList && this.episodesList) {
        if (this.props.applicationState.currentFocus === SEASONFOCUS) {
          this.props.setFocus(BUTTONS_LIST_NONMOVIES[0]);
          this.setState({
            slidePage: resolution.detail.positionListEpisodesUp
          });
        } else if (this.props.applicationState.currentFocus === EPISODEFOCUS) {
          this.props.setFocus(SEASONFOCUS);
        }
      }
    }
  }

  tvodBtnText(assetPrices) {
    let rentLabel;
    let oldRentLabel;
    let purchaseLabel;
    let oldPurchaseLabel;

    const rentCtaData = {};
    const purchaseCtaData = {};

    if (assetPrices && assetPrices.length !== 0) {
      assetPrices.forEach(price => {
        if (price.isRentId === true) {
          rentLabel = `${price.currency} ${price.amount}`;
          rentCtaData.newPriceId = price.priceProduct;
          rentCtaData.newPrice = price.amount;
          rentCtaData.newPriceCurrency = price.currency;
        }
        if (price.isOldRentId === true) {
          oldRentLabel = `${price.currency} ${price.amount}`;
          rentCtaData.oldPriceId = price.priceProduct;
          rentCtaData.oldPrice = price.amount;
          rentCtaData.oldPriceCurrency = price.currency;
        }
        if (price.isPurchaseId === true) {
          purchaseLabel = `${price.currency} ${price.amount}`;
          purchaseCtaData.newPriceId = price.priceProduct;
          purchaseCtaData.newPrice = price.amount;
          purchaseCtaData.newPriceCurrency = price.currency;
        }
        if (price.isOldPurchaseId === true) {
          oldPurchaseLabel = `${price.currency} ${price.amount}`;
          purchaseCtaData.oldPriceId = price.priceProduct;
          purchaseCtaData.oldPrice = price.amount;
          purchaseCtaData.oldPriceCurrency = price.currency;
        }
      });
    }
    return { rentLabel, oldRentLabel, rentCtaData, purchaseLabel, oldPurchaseLabel, purchaseCtaData };
  }

  assetHandler(type, data) {
    const {
      applicationState: { userLogged },
      history: { location }
    } = this.props;
    const { id, title, addonContent, titleData } = this.state;
    let typeTranslated = i18n.get(`global.errors.TVODContentRestriction.${type}`);
    if (userLogged) {
      if (this.isKidsContent && this.kidsProfileEnabled) {
        return showContentNotAccessibleModal.call(this, this.closeModal, {
          name: typeTranslated,
          isTVODContent: true
        });
      }
      const eventAction = type === "rent" ? "rent_now_click" : type === "purchase" && "buy_now_click";
      const eventData = {
        pageType: `details-${titleData.tagList}`,
        pathname: location.pathname,
        titleId: id,
        title,
        addonContent,
        tagList: titleData.tagList,
        price: data.newPrice,
        currency: data.newPriceCurrency,
        profileId: this.currentProfile?.profileId
      };
      trackAndRedirectHandler.call(
        this,
        PAGE,
        eventAction,
        routes.buyasset,
        buyAssetDetails.call(this, type, data),
        TVOD,
        eventData
      );
    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this), null, buyAssetDetails.call(this, type, data));
    }
  }

  DisclaimerText() {
    const { assetPrices } = this.state;
    const rentDisclaimerDays = config.get().rentDisclaimerTime.days;
    const rentDisclaimerHours = config.get().rentDisclaimerTime.hours;
    let text;

    if (assetPrices) {
      if (Object.keys(assetPrices.rentCtaData).length !== 0 && Object.keys(assetPrices.purchaseCtaData).length !== 0) {
        text = i18n.get("pages.detail.disclaimer.rentAndBuy", rentDisclaimerDays, rentDisclaimerHours);
      } else if (
        Object.keys(assetPrices.rentCtaData).length !== 0 &&
        Object.keys(assetPrices.purchaseCtaData).length === 0
      ) {
        text = i18n.get("pages.detail.disclaimer.rent", rentDisclaimerDays, rentDisclaimerHours);
      } else {
        text = i18n.get("pages.detail.disclaimer.purchase");
      }
    }

    return text;
  }

  sponsorBugHandler(titleURL, qrCodeURL) {
    this.showQRCodeModal = true;
    return showQRCodeModal.call(this, this.closeModal, titleURL, qrCodeURL);
  }

  async goToTrailer() {
    const episodesLoaded = !this.isSeries || (await this.episodesLoad);
    const videoData = episodesLoaded && (await getVideoDataForPlayer.call(this, false));
    // Byte+ GA event for play click
    sessionStorage.setItem("currScreen2", sessionStorage.getItem("currentScreen"));
    sessionStorage.setItem("prevScreen2", sessionStorage.getItem("prevScreen"));
    videoData.series_id = this.getContentIdFromUrl();
    sendVideoPlayClickEventDataForBytePlus({
      thisInstance: this,
      mediaData: videoData,
      currentScreen: sessionStorage?.getItem("currentScreen"),
      previousScreen: sessionStorage?.getItem("prevScreen")
    });
    trackAndRedirectHandler.bind(this, PAGE, "trailer", routes.player, getTrailerVideoData.call(this))();
  }

  render() {
    this.lastEpisode = this.props?.location?.state?.lastEpisode;
    const {
      assetPrices,
      tvodStatus,
      addonContent,
      titleSubscriptions = [],
      isOneTimePassPriorityFlag = false,
      isOneTimePassActive = false
    } = this.state;
    const { userLogged, isGuestProfile, addons, isSvodUser } = this.props.applicationState;

    // Calculate the subscription check flag

    let isUserSubscribedToAsset =
      !isTvodFlowForPlayback(tvodStatus) && !isAvodAssets(this.state.titleData?.assetTypes)
        ? isUserSubscribedToChannel(addons, addonContent, titleSubscriptions)
        : true;
    return (
      <DetailWrapperStyled url={this.state.backgroundCover}>
        {this.state.isLoaded ? (
          <DetailContainerStyled
            onWheel={e => {
              this.scrollUpDown(e);
            }}
            position={this.state.slidePage}
          >
            <DetailPageStyled isSeries={this.isSeries}>
              <Detail
                data={this.state.titleData}
                playHandler={this.playHandler}
                trailerHandler={this.goToTrailer.bind(this)}
                addHandler={myListHandler.bind(this)}
                isSavedInMyWatchlist={this.state.isSavedInMyWatchlist}
                separator={config.get().locales[i18n.getLocale()].separator}
                direction={i18n.getDirection()}
                firstEpisodeAvailable={this.state.firstEpisodeAvailable}
                currentFocus={this.props.applicationState.currentFocus}
                isPageSlides={this.state.slidePage < 0 ? true : false}
                isUserLoggedIn={userLogged ? userLogged : isGuestProfile}
                isSeries={this.isSeries}
                assetHandler={(type, data) => this.assetHandler(type, data)}
                sponsorBugHandler={(titleURL, qrCodeURL) => this.sponsorBugHandler(titleURL, qrCodeURL)}
                shouldShowSubscription={!isUserSubscribedToAsset}
                // #NOTE:isOneTimePassPriorityFlag: If one time pass has priority over SVOD, then we should not show the upgrade/subscribe even if user is SVOD user because user needs to buy the content as separate to make it active. We will always show Subscribe
                isActiveUser={
                  isOneTimePassPriorityFlag ? false : isSvodUser ? (!isOneTimePassActive ? true : false) : false
                }
                episodeTags={this.lastEpisode ? this.lastEpisode?.tags || [] : this.state?.titleData?.tags || []}
              />
              {assetPrices && (
                <DisclaimerText>
                  <IconStyled name="indicator" viewBoxValue="0 0 24 24" />
                  <DisclaimerTextStyled text={this.DisclaimerText()} />
                </DisclaimerText>
              )}
            </DetailPageStyled>
            <section
              onClick={() => {
                this.setState({
                  slidePage: -resolution.detail.positionListEpisodesDown
                });
              }}
            >
              {this.isSeries &&
                (this.state.hasEpisodes && this.seasonsList && this.episodesList && this.state.hasAllDataLoaded ? (
                  <EpisodesSelector
                    seasonSelected={this.lastEpisode && this.lastEpisode.tvSeasonNumber}
                    episodeSelected={this.lastEpisode && this.lastEpisode.tvSeasonEpisodeNumber}
                    seasonsList={this.seasonsList}
                    episodesList={this.episodesList}
                    onEnterPress={this.handleEnter}
                    onSeasonChanged={this.seasonChanged}
                    direction={i18n.getDirection()}
                    currentFocus={this.props.applicationState.currentFocus}
                    slideMarginStart={0}
                    MagicRemoteStatus={this.wheelState === "active" ? true : false}
                    showArrows={this.wheelState === "active" ? true : false}
                    fromDetailPage={true}
                    isOnLG={this.state.isOnLG}
                    tvodStatus={tvodStatus}
                    subscriptionStatus={i18n.get("pages.detail.free")}
                    isActiveUser={isSvodUser}
                  />
                ) : (
                  <ArrowScrollStyled
                    label={<Loading width="25px" height="25px" text={i18n.get("pages.detail.loadingEpisodes")} />}
                  />
                ))}
            </section>
          </DetailContainerStyled>
        ) : (
          <Loading overlay />
        )}
      </DetailWrapperStyled>
    );
  }
}

const Component = withAppState(withSubtheme(DetailPage));

Component.defaultFocusPath = Detail.defaultFocusPath;

export default Component;
